import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {ApplyToAllModalComponent} from "./apply-to-all-modal.component";
import {ContentHeaderModule} from "../content-header/content-header.module";
import {CaptionInputModule} from "../inputs/caption/caption.input.module";
import {UserAuthenticationService} from "../../../../user/login/services/user-authentication.service";
import {ImageCardModule} from "../image-card/image-card.module";

/**
 * Apply to All Module
 * @class
 */
@NgModule({
  declarations: [ApplyToAllModalComponent],
  entryComponents: [ApplyToAllModalComponent],
  exports: [ApplyToAllModalComponent],
  imports: [
    IonicModule,
    ContentHeaderModule,
    CaptionInputModule,
    ImageCardModule,
  ],
  providers: [UserAuthenticationService],
})
export class ApplyToAllModalModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/apply-to-all-modal/apply-to-all-modal.module.ts